import urlParse from "url-parse"

export function unsetQueryParam(param: string) {
  const url = urlParse(window.location.href, true)
  delete url.query[param]
  window.history.replaceState({}, "", url.toString())
}
